import { useMutation } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import formsApi from '../api/forms.api';
import { DefaultErrorMessage } from '../displayStrings';
import { useEventFormParams } from './useEventFormParams';
import { UpdateForm } from '../types';
import { useNavigate } from 'react-router-dom';

export const useFormRevertToDraft = (formTitle: string) => {
  const { eventId, stepId, formId } = useEventFormParams();
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const navigate = useNavigate();

  return useMutation(() => formsApi.updateForm(companyId, eventId, stepId, formId, { status: 'draft' }), {
    onSuccess: (data: UpdateForm) => {
      navigate(`/events/${eventId}/steps/${data.issue_step_id}/forms/${data.id}`, { replace: true });
      showToast({
        title: 'Reverted to draft',
        description: `${formTitle} was reverted to draft`,
        status: 'success',
        duration: 5000,
        'data-cy': 'qe-form-revert-success-toast',
      });
    },
    onError: (err: any) => {
      const message = err?.response?.data?.message || DefaultErrorMessage;
      showToast({
        description: message,
        status: 'error',
        duration: 5000,
      });
    },
  });
};
